export const emailIsValid = (email: string) => {
  const simpleEmailRex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return simpleEmailRex.test(String(email).toLowerCase());
};
